(() => {
  const CARD_SELECTOR = '.product-card';

  function parseMoney(text) {
    if (!text) return NaN;
    const normalized = text
      .replace(/\s/g, '')
      .replace(/[^0-9,.-]/g, '')
      .replace(/\.(?=\d{3}(?:\D|$))/g, '')
      .replace(',', '.');
    return Number.parseFloat(normalized);
  }

  function syncCard(card) {
    const salePriceNode = card.querySelector('.f-price__sale .f-price-item--sale');
    const comparePriceNode = card.querySelector('.f-price__sale .f-price-item--regular');
    const badge = card.querySelector('.product-card__badge .f-badge--sale');

    if (!salePriceNode || !comparePriceNode || !badge) return;

    const salePrice = parseMoney(salePriceNode.textContent);
    const comparePrice = parseMoney(comparePriceNode.textContent);
    if (!Number.isFinite(salePrice) || !Number.isFinite(comparePrice) || comparePrice <= salePrice || comparePrice <= 0) return;

    const discount = Math.round(((comparePrice - salePrice) / comparePrice) * 100);
    badge.textContent = `-${discount}%`;
    badge.dataset.peakstyleVisibleDiscount = String(discount);
  }

  function syncAll(root = document) {
    if (root.matches?.(CARD_SELECTOR)) syncCard(root);
    root.querySelectorAll?.(CARD_SELECTOR).forEach(syncCard);
  }

  function init() {
    syncAll();

    let queued = false;
    const observer = new MutationObserver((mutations) => {
      if (queued) return;
      const relevant = mutations.some(({ target, addedNodes }) =>
        target.closest?.(CARD_SELECTOR) || Array.from(addedNodes).some((node) => node.nodeType === 1 && (node.matches?.(CARD_SELECTOR) || node.querySelector?.(CARD_SELECTOR)))
      );
      if (!relevant) return;

      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        syncAll();
      });
    });

    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    document.addEventListener('shopify:section:load', () => syncAll());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
